import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {AuthGuard} from '@core/services/auth-guard.service';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import {AuditTrackerAnalyticsComponent} from '@features/audit-tracker/components/audit-tracker-analytics/audit-tracker-analytics.component';
import {AuditTrackerMagicLinkComponent} from '@features/audit-tracker/components/audit-tracker-magic-link/audit-tracker-magic-link.component';


export const auditTrackerRoutes: Routes = [
  {
    path: 'audit-tracker/dashboard',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/stage/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/cases/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/cases',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/eat/magic-link/:caseId/:recordId',
    component: AuditTrackerMagicLinkComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/eat/magic-link/:caseId',
    component: AuditTrackerMagicLinkComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit-tracker/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  }
];
